import { useIntl } from 'react-intl';
import { Box, Typography, useDeviceType } from '@packages/shared';
import { subscribeSheetMessages } from './helpers/messages';
import { handleSubmit } from '../GeneralForm/helpers/handleSubmit';
import { convertFormDataToPostDataDoiNotification } from './helpers/settings';
import { InputIDs } from '../types';

/**
 * Content for the DOI-Notification, consisting of an info text and a clickable text
 * that requests another Confirmation Email.
 */
export const DoiNotificationContent = ({
  onClickedSuccess,
  onClickedError,
  email,
}: {
  onClickedSuccess: () => void;
  onClickedError: (msg: string) => void;
  email: string;
}) => {
  const intl = useIntl();
  const { isMobile } = useDeviceType();
  return (
    <Box>
      <Typography>{intl.formatMessage(subscribeSheetMessages.doiText, { email })}</Typography>
      <Box
        sx={{ cursor: 'pointer', textDecoration: 'underline', marginTop: 2 }}
        role="button"
        onClick={() =>
          handleSubmit(
            onClickedSuccess,
            onClickedError,
            intl,
            convertFormDataToPostDataDoiNotification({ [InputIDs.EMAIL]: email }),
            'subscribe',
            isMobile ? 'mob' : 'web',
            () => {},
          )
        }
      >
        <Typography>{intl.formatMessage(subscribeSheetMessages.doiLink)}</Typography>
      </Box>
    </Box>
  );
};
